import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage, { Section, List, SUPPORT_EMAIL } from '../Components/LegalPage';

export default function RefundPolicyPage() {
  return (
    <LegalPage
      title="Cancellation & Refund Policy"
      tagline="Cancel any time. If SoapLab Pro isn't right for you, ask within 7 days of a payment for a full refund."
      effective="October 23, 2026"
    >
      <Section id="plans" title="1. What you pay for">
        <p className="bodytext">
          SoapLab has a free plan and a paid Pro subscription, billed monthly or yearly. Prices are shown on
          the <Link to="/pricing">pricing page</Link> before you pay. Customers outside India pay in US dollars
          through PayPal. Customers in India will pay in rupees through Razorpay once Pro opens in India.
        </p>
      </Section>

      <Section id="cancel" title="2. Cancelling">
        <List items={[
          'You can cancel at any time from your account Settings, or by contacting us.',
          'When you cancel, no further payments are taken. Your Pro features stay active until the end of the period you have already paid for, then your account moves to the free plan.',
          'Your recipes and records are not deleted when you cancel.',
        ]} />
      </Section>

      <Section id="refunds" title="3. Refunds">
        <List items={[
          '7-day money-back guarantee: if you ask within 7 days of any subscription payment, we refund that payment in full and cancel the subscription.',
          'After 7 days, payments are not refunded, including for partly used months or years, except where the law requires a refund.',
          'If you are charged twice, charged after cancelling, or charged when Pro did not activate on your account, we refund the incorrect charge in full whenever you report it.',
        ]} />
      </Section>

      <Section id="how" title="4. How to ask for a refund">
        <List items={[
          <span key="contact">Contact us through the <Link to="/contact">Contact page</Link> or email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</span>,
          'Include the email address of your SoapLab account and the payment or transaction ID from your receipt.',
          'We reply within 3 working days. Approved refunds go back to the original payment method (card, UPI, bank account or PayPal).',
          'Once we issue a refund, banks and payment providers usually take 5–7 working days to show it in your account.',
        ]} />
      </Section>

      <Section id="contact" title="5. Questions">
        <p className="bodytext">
          Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> or use the <Link to="/contact">Contact page</Link>.
          This policy forms part of our <Link to="/terms">Terms of Use</Link>.
        </p>
      </Section>
    </LegalPage>
  );
}
